// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3":"f002d07e996b3e64","878":"c8acb7e0452de8d1"}[chunkId] + ".js";
};